import { DescriptionSlide } from "src/pods/conundrums/components/DescriptionSlide";
import { ExpectationsSlide } from "src/pods/conundrums/components/ExpectationsSlide";
import { IntroSlide } from "src/pods/conundrums/components/IntroSlide";
import { OptionsSlide } from "src/pods/conundrums/components/OptionsSlide";
import { PairShareSlide } from "src/pods/conundrums/components/PairShareSlide";
import { ShareToStorySlide } from "src/pods/conundrums/components/ShareToStorySlide";
import { Slide } from "src/pods/conundrums/components/types";
import civicServantsImage from "src/pods/conundrums/assets/civicServantsIntro@2x.jpg";
import doctorImage from "src/pods/conundrums/assets/doctor@2x.png";
import firefighterImage from "src/pods/conundrums/assets/firefighter@2x.png";
import mojoIsland from "src/pods/conundrums/assets/mojoIsland@2x.jpg";
import teacherImage from "src/pods/conundrums/assets/teacher@2x.png";

const questionOptions = {
  doctors: {
    option: "Doctors",
    icon: doctorImage,
  },
  firefighters: {
    option: "Firefighters",
    icon: firefighterImage,
  },
  teachers: {
    option: "Teachers",
    icon: teacherImage,
  },
};

const slide2Options = [questionOptions.doctors, questionOptions.firefighters];
const slide3Options = [questionOptions.doctors, questionOptions.firefighters, questionOptions.teachers];
const title = "Civic Servants";
const description = "Mojo is the mayor of Monster Island, and must decide:";
const questionText = "Who should be paid the most money? Why?";
const theSentenceStarter = "_____ should be paid the most because...";

const activities: Slide[] = [
  IntroSlide(title, description, questionText, civicServantsImage),
  ExpectationsSlide(),
  DescriptionSlide("Mojo is the mayor of Monster Island and needs to make an important decision!", mojoIsland),
  OptionsSlide(questionText, slide2Options, [{ option: "Teachers", icon: teacherImage }], theSentenceStarter),
  OptionsSlide(questionText, slide3Options, undefined, theSentenceStarter),
  PairShareSlide(
    "Did you like discussing with your classmates? Why?\nWas it hard? Why or why not?\nWhat else did you notice?",
  ),
  ShareToStorySlide(
    "Congrats on completing this Conundrum!",
    "Now that was an interesting question indeed.",
    "https://static.classdojo.com/img/civilServantsShare.png",
    "Great discussion!",
  ),
];

export default activities;
